export const name = 'builderComponent' as const
// Editor-specific VSM experiment (distinct from the viewer's). Defined once here and imported by BOTH
// the central Carmi exclusion (editorFeatures.carmi.ts) and the VSM side — never a re-typed literal.
export const editorExperiment = 'specs.thunderbolt.vsmEditorBuilderComponent' as const
export const BuilderComponentLoaderSymbol = Symbol('BuilderComponentLoader')
export const BuilderComponentRegistrarSymbol = Symbol('BuilderComponentRegistrar')
export const BuilderComponentStyleApiSymbol = Symbol('BuilderComponentStyleApi')
export const BuilderComponentResolverSymbol = Symbol('BuilderComponentResolver')
export const BuilderComponentWarmupDataEnricherSymbol = Symbol('BuilderComponentWarmupDataEnricher')
export const BuilderResourcesManagerSymbol = Symbol('BuilderResourcesManager')
export const CompTypeToAllDescendantsHandlerSymbol = Symbol('CompTypeToAllDescendantsHandler')
